<div class="flex-area">
  <div class="flex back">
    <a class="back" href="javascript:;" (click)="previous()" aria-label="Back">
      <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </a>
  </div>
  <div #trackContainer class="track-container">
    <div class="track" [style.left]="-scrollOffset+'px'">
      <ng-content></ng-content>
    </div>
  </div>
  <div class="flex forward">
    <a class="forward" href="javascript:;" (click)="next()" aria-label="Forward">
      <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </a>
  </div>
</div>